import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './router.config'

Vue.use(Router)

const router = new Router({
  routes,
})

// 获取原型对象push函数
const originalPush = Router.prototype.push

// 获取原型对象replace函数
const originalReplace = Router.prototype.replace

// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js